export default {
  sort: 3,
  path: '/edit-index/:id',
  name: 'Edit-Index',
  component: () => import('@/views/edit-index'),
}


// WEBPACK FOOTER //
// ./src/router/modules/edit-index.js